module.exports = {
      id: "adguard_1_icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "images/js_src_vue/page_adguard_landing/sprite.dab809d9.svg#adguard_1_icon-usage",
      toString: function () {
        return this.url;
      }
    }